import { FaInstagram, FaItchIo, FaTiktok } from 'react-icons/fa';

const SocialLinks = () => {
  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 flex gap-2 sm:gap-3 z-40">
      <a 
        href="https://www.instagram.com/nuclearteam1/" 
        target="_blank"
        rel="noreferrer"
        className="secondary-button backdrop-blur-md p-2 sm:p-3 rounded-full text-white hover:text-pink-200 transform hover:-translate-y-0.5 transition-all duration-300"
        aria-label="Instagram"
      >
        <FaInstagram size={20} className="sm:w-6 sm:h-6" />
      </a>
      <a 
        href="https://www.tiktok.com/@nuclear.team1" 
        target="_blank"
        rel="noreferrer"
        className="secondary-button backdrop-blur-md p-2 sm:p-3 rounded-full text-white hover:text-cyan-200 transform hover:-translate-y-0.5 transition-all duration-300"
        aria-label="TikTok"
      >
        <FaTiktok size={20} className="sm:w-6 sm:h-6" />
      </a>
      <a
        href="https://nuclearteam.itch.io/"
        target="_blank"
        rel="noreferrer"
        className="secondary-button backdrop-blur-md p-2 sm:p-3 rounded-full text-white hover:text-red-300 transform hover:-translate-y-0.5 transition-all duration-300"
        aria-label="Nuclear Team en itch.io"
        title="itch.io"
      >
        <FaItchIo size={20} className="sm:w-6 sm:h-6" />
      </a>
    </div>
  );
};

export default SocialLinks;
